<template>
    <div class="box box-success box-races">
        <div class="box-header with-border"><h4 class="box-title">Series
            Entry:{{registrationCategorySeries.name}}</h4>
            <p>Closing Date: {{registrationCategorySeries.closing_date | dateFormat('Europe/London')}}</p>
            <p class="no-margin">{{registrationCategorySeries.registration_categories.length}} races in series</p>

            <div class="box-tools pull-right text-right text-sm-center text-xs-center">
                <status-badge :status="registrationCategorySeries.human_status"></status-badge>
                <br>
                Current Price: {{registrationCategorySeries.price_range}}
            </div>

        </div>
        <div class="box-body" v-show="showContent">
            <h5>Series description</h5>
            {{registrationCategorySeries.description}}
            <h5>Events in this series</h5>
            <table class="table table-striped">
                <thead>
                <tr>
                    <th class="col-md-3">Date:</th>
                    <th>{{calendar ? calendar.registration_category_term : 'Race'}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(registrationCategory, index) in registrationCategorySeries.registration_categories">
                    <td class="col-md-3">{{registrationCategory.date |
                        dateFormat(registrationCategory.occasion.timezone, 'DD/MM/YY HH:mm')}}
                    </td>
                    <td>{{registrationCategory.name}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="box-footer text-center">
            <button class="btn btn-success btn-sm" @click="showContent = !showContent">{{ showContent ? 'Hide Series Details' : 'View Series Details' }}
            </button>
        </div>
    </div>
</template>

<script>
    import StatusBadge from "../Participants/StatusBadge.vue";
    import {dateFormat} from '../Utility/filters/dates'

    export default {
        name: "RegistrationCategorySeriesCard",
        components: {StatusBadge},
        props: {
            registrationCategorySeries: {
                type: Object,
                default: () => ({}),
                required: true
            },
            calendar: {
                type: Object,
                default: () => ({}),
                required: false
            },
        },
        components: {
            StatusBadge
        },
        filters: {
            dateFormat
        },
        data() {
            return {
                showContent: false
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Assets/components/RegistrationCategorySeries/Card.vue